import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
import PostControls from 'flarum/forum/utils/PostControls';
import DiscussionControls from 'flarum/forum/utils/DiscussionControls';
const t = key => app.translator.trans(`tarotportal-theme.forum.confirm.${key}`, {}, true);
/**
 * Confirmation for irreversible actions only (deleting forever), in place of the browser's
 * confirm(): core's Modal (backdrop, ×, Escape, outside click, focus trap, page scroll lock)
 * with a short explanation, [Отмена] and a destructive [Удалить навсегда]. While the action
 * runs the buttons are disabled, so it cannot be sent twice.
 */
export class TpConfirmModal extends Modal {
  className() {
    return 'TpConfirmModal Modal--small';
  }
  title() {
    return this.attrs.title;
  }
  content() {
    return m("div", {
      className: "Modal-body"
    }, m("p", {
      className: "TpConfirmModal-text"
    }, this.attrs.text), m("div", {
      className: "TpConfirmModal-actions"
    }, m(Button, {
      className: "Button TpConfirmModal-cancel",
      disabled: this.loading,
      onclick: () => this.hide()
    }, this.attrs.cancelLabel || t('cancel')), m(Button, {
      className: "Button Button--danger TpConfirmModal-confirm",
      disabled: this.loading,
      loading: this.loading,
      onclick: () => this.confirm()
    }, this.attrs.confirmLabel)));
  }

  // The safe choice has the focus first
  onready() {
    this.$('.TpConfirmModal-cancel').trigger('focus');
  }
  async confirm() {
    if (this.loading) return;
    this.loading = true;
    m.redraw();

    // the buttons stay disabled until the window has closed (core shows any request error)
    try {
      await this.attrs.onconfirm();
    } finally {
      this.hide();
    }
  }
}

/** Asks first, then runs `action` — for irreversible actions only. */
export function confirmDanger(attrs) {
  app.modal.show(TpConfirmModal, attrs);
}

/**
 * Runs core's own action, whose first step is the browser's confirm(): that question has just
 * been answered in TpConfirmModal, so for this one synchronous call it is answered "yes".
 */
function confirmed(action) {
  const ask = window.confirm;
  window.confirm = () => true;
  try {
    return action();
  } finally {
    window.confirm = ask;
  }
}
export default function addDangerConfirmations() {
  // Post → "Удалить навсегда" (core's PostControls.deleteAction: same request, permissions, stream update)
  override(PostControls, 'deleteAction', function (original, context) {
    confirmDanger({
      title: t('delete_post_title'),
      text: t('delete_post_text'),
      confirmLabel: t('delete_forever'),
      onconfirm: () => confirmed(() => original(context))
    });
  });

  // Discussion → "Удалить навсегда" (core's DiscussionControls.deleteAction)
  override(DiscussionControls, 'deleteAction', function (original) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    confirmDanger({
      title: t('delete_discussion_title'),
      text: t('delete_discussion_text'),
      confirmLabel: t('delete_forever'),
      onconfirm: () => confirmed(() => original(...args))
    });
  });
}